function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 38,
  height: 5,
  fill: "#0084ff"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(47)",
  fill: "#ffc000"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(94)",
  fill: "#0084ff"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-4",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(141)",
  fill: "#0084ff"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(188)",
  fill: "#0084ff"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-6",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(235)",
  fill: "#0084ff"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-7",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(282)",
  fill: "#0084ff"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-8",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(329)",
  fill: "#9ea1a6"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-9",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(376)",
  fill: "#0084ff"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-10",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(423)",
  fill: "#0084ff"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-11",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(470)",
  fill: "#0084ff"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-12",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(517)",
  fill: "#0084ff"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-13",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(564)",
  fill: "#0084ff"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-14",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(611)",
  fill: "#0084ff"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-15",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(658)",
  fill: "#0084ff"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-16",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(704)",
  fill: "#0084ff"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-17",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(751)",
  fill: "#0084ff"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-18",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(798)",
  fill: "#0084ff"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-19",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(845)",
  fill: "#0084ff"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-20",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(892)",
  fill: "#0084ff"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-21",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(939)",
  fill: "#ffc000"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-22",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(986)",
  fill: "#0084ff"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-23",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(1033)",
  fill: "#0084ff"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-24",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(1080)",
  fill: "#0084ff"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-25",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(1127)",
  fill: "#0084ff"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-26",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(1174)",
  fill: "#0084ff"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-27",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(1221)",
  fill: "#0084ff"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-28",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(1268)",
  fill: "#0084ff"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-29",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(1315)",
  fill: "#0084ff"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-30",
  "data-name": "Rectangle",
  width: 38,
  height: 5,
  transform: "translate(1362)",
  fill: "#9ea1a6"
});

function SvgLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 5,
    viewBox: "0 0 1400 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.7c1abff3.svg";
export { ForwardRef as ReactComponent };